import { render } from "./About.vue?vue&type=template&id=4ac6bbf0&ts=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=4ac6bbf0&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__